import { render, staticRenderFns } from "./textBase.vue?vue&type=template&id=340edfc2&scoped=true"
import script from "./textBase.vue?vue&type=script&lang=js"
export * from "./textBase.vue?vue&type=script&lang=js"
import style0 from "./textBase.vue?vue&type=style&index=0&id=340edfc2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340edfc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('340edfc2')) {
      api.createRecord('340edfc2', component.options)
    } else {
      api.reload('340edfc2', component.options)
    }
    module.hot.accept("./textBase.vue?vue&type=template&id=340edfc2&scoped=true", function () {
      api.rerender('340edfc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseTemplate/textBase.vue"
export default component.exports